let SkeletonVariant = /*#__PURE__*/function (SkeletonVariant) {
  SkeletonVariant["TEXT"] = "text";
  SkeletonVariant["CIRCLE"] = "circle";
  SkeletonVariant["RECT"] = "rect";
  return SkeletonVariant;
}({});

export { SkeletonVariant };
//# sourceMappingURL=variant.js.map
